import { Block } from "Content/Block";
import { ServicesContainer } from "./style";
import { Card, CardContainer } from "Content/style";
import { Caption } from "Content/Caption";
import services1 from "res/services_1.jpg";
import services2 from "res/services_2.jpg";
import services3 from "res/services_3.jpg";
import origServices1 from "res/services/orig_services_1.jpg";
import origServices2 from "res/services/orig_services_2.jpg";
import origServices3 from "res/services/orig_services_3.jpg";
import extendedServices1 from "res/extended_services_1.jpg";
import extendedServices2 from "res/extended_services_2.jpg";
import extendedServices3 from "res/extended_services_3.jpg";
import origExtendedServices1 from "res/services/orig_extended_services_1.jpg";
import origExtendedServices2 from "res/services/orig_extended_services_2.jpg";
import origExtendedServices3 from "res/services/orig_extended_services_3.jpg";
import { StylingList } from "./style";
import { StylingListItem } from "./style";
import { ExtendedServicesHeadline } from "./style";
import { ExtendedServiceRow } from "./ExtendedServiceRow";
import { ExtendedServicesColumn } from "./style";
import { Image } from "Image";
import { direction } from "Util/direction";

export const Services = ({ setImgSrc }) => {
  return (
    <div id="services">
      <Block caption={"Leistungen"}>
        <ServicesContainer>
          <div>
            <p>
              Ich selbst bin ein natürlicher Mensch und das wiederum spiegelt
              sich in meinen Stylings wieder.{" "}
            </p>
            <p>
              Denn mir ist wichtig, die Schönheit eines Menschen zu betonen,
              ohne diese zu überschatten. Das aller wichtigste ist jedoch, dass
              du dich wohlfühlst!
            </p>
          </div>
        </ServicesContainer>
        <Block caption={"Brautstyling"} captioninblock>
          <CardContainer>
            <Card>
              <h3>Paket 1</h3>
              <ul>
                <li>
                  Hairstyling komplett mit allen Utensilien (Haargummi,
                  Haarnadeln, Haarkissen...) ODER Make-up langanhaltend &
                  typgerecht auf Wunsch mit Wimpern
                </li>
                <li>Probetermin mit Beratung</li>
                <li>Bride Guide</li>
                <li>kleines Dankeschön für dich</li>
                <li>
                  zuverlässige Betreuung von der Buchung bis zum großen Tag
                </li>
              </ul>
            </Card>
            <Card>
              <h3>Paket 2</h3>
              <ul>
                <li>
                  Hairstyling komplett mit allen Utensilien (Haargummi,
                  Haarnadeln, Haarkissen...)
                </li>
                <li>
                  Make-up langanhaltend & typgerecht auf Wunsch mit Wimpern
                </li>
                <li>Probetermin mit Beratung</li>
                <li>Bride Guide</li>
                <li>kleines Dankeschön für dich</li>
                <li>
                  zuverlässige Betreuung von der Buchung bis zum großen Tag
                </li>
              </ul>
            </Card>
            <Card>
              <h3>Paket 3</h3>
              <ul>
                <li>
                  Hairstyling komplett mit allen Utensilien (Haargummi,
                  Haarnadeln, Haarkissen...)
                </li>
                <li>
                  Make-up langanhaltend & typgerecht auf Wunsch mit Wimpern
                </li>
                <li>Probetermin mit Beratung</li>
                <li>Bride Guide</li>
                <li>kleines Dankeschön für dich</li>
                <li>
                  zuverlässige Betreuung von der Buchung bis zum großen Tag
                </li>
                <li>
                  1x Gästehairstyling (für Trauzeugin, Schwester, Mutter...)
                </li>
              </ul>
            </Card>
          </CardContainer>
        </Block>
        <Caption text={"Preise auf Anfage"} inblock fontSize={18} smallruler />
        <CardContainer bypassBreakpoint>
          <Card>
            <Image
              setImgSrc={setImgSrc}
              direction={direction.landscape}
              thumbnailSrc={services1}
              originalSrc={origServices1}
              width={"100%"}
            />
          </Card>
          <Card hideMobile>
            <Image
              setImgSrc={setImgSrc}
              direction={direction.portrait}
              thumbnailSrc={services2}
              originalSrc={origServices2}
              width={"100%"}
            />
          </Card>
          <Card>
            <Image
              setImgSrc={setImgSrc}
              direction={direction.landscape}
              thumbnailSrc={services3}
              originalSrc={origServices3}
              width={"100%"}
            />
          </Card>
        </CardContainer>
        <p>
          Nach dem Probestyling, bekommst du die erste Rechnung von mir
          zugeschickt.
        </p>
        <p>
          Eine Woche vor der Hochzeit kommt die zweite Rechnung die beglichen
          werden muss.
        </p>
        <p>
          Sehr gerne komme ich am Hochzeitstag zu dir vor Ort, sodass du ganz
          enspannt in den Tag starten kannst. Hierfür berechne ich 45 ct pro
          gefahrenen km.
        </p>
        <Block caption={"Styling für jeden Anlass"} captioninblock>
          <StylingList>
            <StylingListItem>Hochzeitsgast</StylingListItem>
            <StylingListItem>Abschlussball</StylingListItem>
            <StylingListItem>JGA</StylingListItem>
          </StylingList>
          <StylingList>
            <StylingListItem>Privatshooting</StylingListItem>
            <StylingListItem>Babybauch</StylingListItem>
            <StylingListItem>Familie</StylingListItem>
          </StylingList>
          <CardContainer>
            <Card>
              <ExtendedServicesColumn>
                <ExtendedServicesHeadline>Hairstyling</ExtendedServicesHeadline>
                <ExtendedServiceRow
                  index={1}
                  name={"HAIRSTYLING NATURAL"}
                  items={["Beachwaves / Wellen / Locken / glatt"]}
                  price={55}
                />
                <ExtendedServiceRow
                  index={2}
                  name={"HAIRSTYLING UPDO"}
                  items={[
                    "Halb-offen oder komplett gesteckt mit allen Utensilien",
                  ]}
                  price={75}
                />
              </ExtendedServicesColumn>
            </Card>
            <Card>
              <ExtendedServicesColumn>
                <ExtendedServicesHeadline>Make-Up</ExtendedServicesHeadline>
                <ExtendedServiceRow
                  index={1}
                  name={"MAKE-UP NATURAL"}
                  items={["Tagesmake-Up, typgerecht & langanhaltend"]}
                  price={55}
                />
                <ExtendedServiceRow
                  index={2}
                  name={"MAKE-UP GLAMOURES"}
                  items={[
                    "Smokey Eyes / Cut Crease... stark betont, langanhaltend mit Wimpern",
                  ]}
                  price={75}
                />
                <ExtendedServiceRow
                  index={3}
                  name={"WIMPERN"}
                  items={["Wimpern verdichten mit Einzelwimpern"]}
                  price={15}
                />
              </ExtendedServicesColumn>
            </Card>
          </CardContainer>
          <CardContainer bypassBreakpoint>
            <Card>
              <Image
                setImgSrc={setImgSrc}
                direction={direction.portrait}
                thumbnailSrc={extendedServices1}
                originalSrc={origExtendedServices1}
                width={"100%"}
              />
            </Card>
            <Card hideMobile>
              <Image
                setImgSrc={setImgSrc}
                direction={direction.landscape}
                thumbnailSrc={extendedServices2}
                originalSrc={origExtendedServices2}
                width={"100%"}
              />
            </Card>
            <Card>
              <Image
                setImgSrc={setImgSrc}
                direction={direction.portrait}
                thumbnailSrc={extendedServices3}
                originalSrc={origExtendedServices3}
                width={"100%"}
              />
            </Card>
          </CardContainer>
        </Block>
      </Block>
    </div>
  );
};
